import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from './styles.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export default function CTAFinal() {
  const { t } = useTranslation('landing');

  const steps = t('ctaFinal.steps', { returnObjects: true });

  return (
    <motion.section
      id="cta"
      className={styles.section}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className={styles.container}>
        <h2 className={styles.title}>
          {t('ctaFinal.titleLine1')}<br />
          <em>{t('ctaFinal.titleLine2')}</em>?
        </h2>
        <p className={styles.subtitle}>
          {t('ctaFinal.subtitle1')}
          <br />
          {t('ctaFinal.subtitle2')}
        </p>
        <div className={styles.flow}>
          {steps.map((step, i) => (
            <span key={i} className={styles.flowGroup}>
              <span className={styles.step}>
                <span className={styles.num}>{i + 1}</span>
                {step}
              </span>
              {i < steps.length - 1 && <span className={styles.sep}>→</span>}
            </span>
          ))}
        </div>
        <a href="mailto:comercial@nativapps.com" className={styles.btnPrimary}>
          {t('ctaFinal.cta')}
        </a>
        <p className={styles.note}>{t('ctaFinal.note')}</p>
      </div>
    </motion.section>
  );
}
